import { mountRedirect } from "../../utils/redirect.service"

function Link(props) {
  const actionType = typeof props.action
  if (actionType === "function") {
    return <span onClick={props.action}> {props.children} </span>
  }
  if (actionType === "string") {
    return <span onClick={mountRedirect(props.action)}> {props.children} </span>
  }
  return props.children
}

export default Link
